import React, { useEffect, useState } from "react";
import { adminPredictions } from "../../adminApi";
import { Bot, Calendar, Loader2 } from "lucide-react";

function fmt(d) {
  if (!d) return "-";
  return new Date(d).toLocaleString("es-DO");
}

export default function AdminPredictions() {
  const [preds, setPreds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setPreds(await adminPredictions());
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-extrabold text-gray-900 flex items-center gap-2 mb-1">
        Predicciones <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs font-bold">PRO</span>
      </h2>
      <p className="text-sm text-gray-500 mb-5">Historial de predicciones generadas por Prometeo.</p>

      {loading ? (
        <p className="text-gray-500"><Loader2 className="w-5 h-5 animate-spin inline" /> Cargando...</p>
      ) : preds.length === 0 ? (
        <p className="text-gray-500">No hay predicciones aún.</p>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {preds.map((p) => (
            <div key={p.day} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2 text-gray-800">
                  <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-amber-500 to-red-500 text-white flex items-center justify-center">
                    <Bot className="w-4 h-4" />
                  </div>
                  <div>
                    <p className="font-bold flex items-center gap-1 text-sm"><Calendar className="w-3.5 h-3.5" /> {p.day}</p>
                    <p className="text-[11px] text-gray-500">Generado {fmt(p.generated_at)}</p>
                  </div>
                </div>
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${
                  p.source === "claude-sonnet-4-5" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"
                }`}>
                  {p.source}
                </span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-xs">
                {(p.strong_numbers || []).map((s, i) => (
                  <div key={i} className="bg-blue-50 border border-blue-100 rounded-lg px-2 py-1.5">
                    <p className="text-[10px] text-gray-500">{s.label}</p>
                    <p className="font-bold text-[#0e4a7a]" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                  </div>
                ))}
                <div className="bg-emerald-50 border border-emerald-100 rounded-lg px-2 py-1.5">
                  <p className="text-[10px] text-gray-500">Fuerte</p>
                  <p className="font-bold text-emerald-700" style={{ fontFamily: "'Playfair Display', serif" }}>{p.single_strong}</p>
                </div>
                <div className="bg-purple-50 border border-purple-100 rounded-lg px-2 py-1.5">
                  <p className="text-[10px] text-gray-500">Palé</p>
                  <p className="font-bold text-purple-700" style={{ fontFamily: "'Playfair Display', serif" }}>{p.recommended_pale}</p>
                </div>
                <div className="bg-amber-50 border border-amber-100 rounded-lg px-2 py-1.5">
                  <p className="text-[10px] text-gray-500">VIP</p>
                  <p className="font-bold text-amber-700" style={{ fontFamily: "'Playfair Display', serif" }}>{p.vip_pale}</p>
                </div>
              </div>
              {p.analysis && (
                <p className="mt-3 text-xs text-gray-600 italic border-t border-gray-100 pt-2">“{p.analysis}”</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
